export const getWorkspaceId = () => {
    const sessionWorkspaceId = sessionStorage.getItem('workspaceId');
    const lastWorkspaceId = localStorage.getItem('workspaceId');

    return !!sessionWorkspaceId?.length ? sessionWorkspaceId : lastWorkspaceId; 
}